<app-theme-form
    mode="create"
    [isSubmitting]="submitting()"
    (formSubmit)="onSubmit($event)"
></app-theme-form>
